import { createAction } from 'redux-act';

import MergedTable from '../../../models/interfaces/layout/MergedTable';
import { Reservation, ReservationSeating, SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import ReservationAcceptState from '../../../models/interfaces/reservation/ReservationAcceptState';
import ReservationRejectReason from '../../../models/interfaces/reservation/ReservationRejectReason';
import TimestampPayload from '../TimestampPayload';
import ReservationPayload from './ReservationPayload';

export interface AcceptReservationPayload extends ReservationPayload {
  pendingReservation: Reservation;
  seating?: ReservationSeating;
  mergedTable?: MergedTable;
}

export const acceptReservation = createAction<AcceptReservationPayload>('ACCEPT_RESERVATION');

export interface ReservationAcceptedPayload extends TimestampPayload, ReservationPayload {
  reservation: SeatedReservation;
  createdMergedTable: MergedTable | null;
  acceptState: ReservationAcceptState | undefined;
}
export const reservationAccepted = createAction<ReservationAcceptedPayload>('RESERVATION_ACCEPTED');

export interface ReservationAcceptFailedPayload extends TimestampPayload, ReservationPayload {
  reservationUuid: string;
  rejectReason: ReservationRejectReason | undefined;
}
export const reservationAcceptFailed = createAction<ReservationAcceptFailedPayload>('RESERVATION_ACCEPT_FAILED');
